import { render, staticRenderFns } from "./MyPictureDetail.vue?vue&type=template&id=21aece41&scoped=true"
import script from "./MyPictureDetail.vue?vue&type=script&lang=js"
export * from "./MyPictureDetail.vue?vue&type=script&lang=js"
import style0 from "./MyPictureDetail.vue?vue&type=style&index=0&id=21aece41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aece41",
  null
  
)

export default component.exports